<template>
  <div id="app" style="position: relative;">
    <div style="position: absolute; top: 0; opacity: 0;">
      <img src="/static/img/achuanqi.png" alt />
    </div>
    <router-view :style="{ minHeight: Height + 'px' }" />
    <!-- <app-footer v-show="!(path === '/client' || path === '/phone' || path === '/teamwork' || path === '/myGame/gameDetail')"></app-footer> -->
    <app-footer v-if="path != '/' && path != '/home/index'"></app-footer>
  </div>
</template>
<script>
import AppFooter from "./components/footer.vue";
import { getBlackWords } from "@/req/home";
import { WordFilter } from "@/utils/WordFilter";
export default {
  data() {
    return {
      path: "",
      paths: "",
      Height: 0,
      modelShow: false,
    };
  },
  created() {
    if (this.isMobile()) {
      location.href = "http://wap.996box.com";
    } else {
      this.modelShow = true;
    }
    this.getLexicon();
  },
  mounted() {
    // 对比当前path
    this.path = this.$route.path;
    // 动态获取当前高度-header+footer的宽度让footer始终居底
    this.Height = document.documentElement.clientHeight;
    this.$store.state.user.minHeight = this.Height; // 监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight;
      this.$store.state.user.minHeight = this.Height;
    };
  },
  components: {
    AppFooter,
  },
  methods: {
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    async getLexicon() {
      const res = await getBlackWords();
      if (res.code === 200) {
        WordFilter.instance().init(res.data);
      }
    },
  },
  // 配置监听path
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: "Microsoft YaHei";
  background-color: #efefef;
  overflow-y: hidden;
  min-width: 1200px;
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   top: 0;
  //   bottom: 0;
  //  :style="{minHeight: height+'px'}"
  // console.log(document.documentElement.clientHeight)
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>
